export const transformKnowledgeBaseData = (kb) => ({
    id: kb.id,
    name: kb.name,
    description: kb.description,
    entries: [
        ...kb.preview_entries.map(entry => ({
            type: entry.entry_type === 'business_info' ? 'business' : 'qa',
            ...(entry.entry_type === 'business_info'
                ? { content: entry.data.content }
                : {
                    question: entry.data.question,
                    answer: entry.data.answer
                }
            ),
            id: entry.id
        }))
    ],
    businessInfoCount: kb.business_info_count,
    qaCount: kb.qa_count,
    totalEntries: kb.entry_count
}); 